
<template>
  <div>
    <div class="lptActionsHeader">Actions</div>
    <draggable
            handle=".actionHandle"
            class="dragArea list-group" 
            :list="actions" 
            :group="{ name: 'dragActions', pull: 'clone', put: false }"
    >
      <div class="lptActionWrapper">
          <div
            class="lptActionListItem"
            v-for="element in actions"
            :key="element.type"
          >
          <el-row class="actionRow">   
          <el-col :span="18">  
            {{element.name}}
          </el-col>
          <el-col class="actionAdd" :span="6">
            <div class="addButtonWrapper">
              <el-button v-on:click="addToScenario(element.type)" type="primary" icon="el-icon-circle-plus" size="mini" circle></el-button>
            </div>
          </el-col>
          </el-row>
          </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'Actions',
  data () {
    return {
      actions: [//i shoud prolly move it to an outer cfg, it has zero dynamics and zero business in being here
          {
                type: 'yandex_search',
                name: 'Search in Yandex',
                default: {
                  "id": 0,
                  "name": "yandex_search",
                  "params": {
                    "required":true,
                    "plus_domain":false,
                    "save_organic_urls":false,
                    "uri": "",
                    "page_depth": 10,
                    "mode": "random",
                    "values": [
                    ],
                    "se_uri": "https://ya.ru",
                    "lr": "",
                    "use_suggestions":"never",
                    "rejection_min_time":"0",
                    "rejection_max_time":"0",
                    "rejections_count_min":"0",
                    "rejections_count_max":"0",
                    "click_random_url_match": false,
                    "exclude_urls": [],
                    "tv_projectid": ""
                  },
                  "conditions": []
                },
          },
          {
                type: 'google_search',
                name: 'Search in Google',
                default: {
                  "id": 0,
                  "name": "google_search",
                  "params": {
                    "required":true,
                    "plus_domain":false,
                    "uri": "",
                    "page_depth": "5",
                    "mode": "random",
                    "values": [
                    ],
                    "se_uri": "https://www.google.com",
                    "use_suggestions":"never",
                    "tv_projectid": ""
                  },
                  "conditions": []
                }
          },
          {
                type: 'open',
                name: 'Open site',
                default: {
                  "id": 0,
                  "name": "open",
                  "params": {
                    "uri": "",
                    "referer": "",
                    "mode":"random"
                  },
                  "conditions": []
                },
          },
          {
                type:'click',
                name: 'Click',
                default: {
                  "id": 0,
                  "name": "click",
                  "params": {
                    "selector": "",
                    "xpath": "",
                    "required": false,
                    "validation": "none"
                  },
                  "conditions": []
                }
          },
          {
                type:'wait',
                name: 'Wait',
                default: {
                  "id": 0,
                  "name": "wait",
                  "params": {
                    "min_time": 0,
                    "max_time": 0,
                  },
                  "conditions": []
                }
          },
          {
                type:'read_page',
                name: 'Read page',
                default: {
                  "id": 0,
                  "name": "read_page",
                  "params": {
                    "selector":"",
                    "min_time": 0,
                    "max_time": 0,
                  },
                  "conditions": []
                }
          },
          {
                type:'hover',
                name: 'Hover',
                default: {
                  "id": 0,
                  "name": "hover",
                  "params": {
                    "selector":"",
                    "xpath": "",
                  },
                  "conditions": []
                }
          },
          {
                type:'insert_multi',
                name: 'Insert multi',
                default: {
                  "id": 0,
                  "name": "insert_multi",
                  "params": {
                    "selector":"",
                    "xpath": "",
                    "mode":"random",
                    "values":[],
                    "source":"keyboard",
                    "override": false,
                    "submit": false
                  },
                  "conditions": []
                }
          },
          {
                type:'element_presence',
                name: 'Element presence',
                default: {
                  "id": 0,
                  "name": "element_presence",
                  "params": {
                    "selector":"",
                    "xpath": "",
                    "required":false,
                    "delay_before_check" : 0,
                    "max_wait_time": 0
                  },
                  "conditions": []
                }
          },
          {
                type:'send_content',
                name: 'Send content',
                default: {
                  "id": 0,
                  "name": "send_content",
                  "params": {
                    "selector":"",
                    "xpath": "",
                    "remote_url":'',
                    "api_key" : '',
                    "param": 'file'
                  },
                  "conditions": []
                }
          },
          {
                type:'set_cookie',
                name: 'Set Cookie',
                default: {
                  "id": 0,
                  "name": "set_cookie",
                  "params": {
                    "url": "",
                    "domain": "",
                    "name": "",
                    "value": "",
                    "expires": "+1 day"
                  },
                  "conditions": []
                }
          },
          {
                type:'end_of_task',
                name: 'End of task',
                default: {
                  "id": 0,
                  "name": "end_of_task",
                  "params": {
                    "finish_task_percentage":"0"
                  },
                  "conditions": []
                }
          },
          {
                type:'success_state',
                name: 'Success state',
                default: {
                  "id": 0,
                  "name": "success_state",
                  "params": {
                  },
                  "conditions": []
                }
          },
          {
            type:'save_page_as_pdf',
            name: 'Save page as PDF',
            default: {
              "id": 0,
              "name": "save_page_as_pdf",
              "params": {},
              "conditions": []
            }
          },
          {
            type:'set_url_blocklist',
            name: 'Set URL Blocklist',
            default: {
              "id": 0,
              "name": "set_url_blocklist",
              "params": {
                "urls": [],
              },
              "conditions": []
            }
          },
          {
            type:'donor_acceptor',
            name: 'Donor Acceptor',
            default: {
              'id': 0,
              'name': 'donor_acceptor',
              'params': {
                'donor_uri': [],
                'uri': [],
                'referer': [],
                'mode': 'random',
                'max_time': 0,
                'min_time': 0,
                'safe_mode': false,
                'continue_on_http_404': false,
              },
              'conditions': []

            }
          },
          {
                type:'avito_registration',
                name: 'Avito Registration',
                default: {
                  "id": 0,
                  "name": "avito_registration",
                  "params": {
                  },
                  "conditions": []
                }
          },
          {
                type: 'yandex_image_search',
                name: 'Search Images in Yandex',
                default: {
                  "id": 0,
                  "name": "yandex_image_search",
                  "params": {
                    "target_uri": [],
                    "values": [],
                    "se_uri": "https://ya.ru",
                    "use_suggestions":"never",                    
                    "lr": "",
                    "finish_task_percentage": 0,
                    "save_image_percentage": 0,
                    "watch_uri": []
                  },
                  "conditions": []
                },
          },
      ],
    }
  },

  methods: {
    initializeScenario() {
      if (this.$store.state.bot.bot.data.scenario == null) {
        this.$store.state.bot.bot.data.scenario = [];//shound prolly put in somewhere at the transport layer or require from API
      } 
    },
    addToScenario(type) {
      //i need to access scenario, calculate its size, assign an id, push to array
      this.initializeScenario();
      var model = this.actions.filter(element => element.type == type)[0].default;
      this.$store.state.bot.bot.data.scenario = JSON.parse(JSON.stringify(this.$store.state.bot.bot.data.scenario));//we need it to kill all the reactivity
      model.id = this.$store.state.bot.bot.data.scenario.length + 1;
      this.$store.state.bot.bot.data.scenario.push(
        //we need a default structure for each one of them.
        //i'm gonna need another service for that
        model
      )
    }
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>
.lptActionWrapper{
  
}
.lptActionListItem:nth-child(odd){
  background-color: #dee1ec;
}
.addButton {
  
  width: 25px;
}
.actionAdd{
  
}
.actionRow{
  //margin-top:-20px;
}
.lptActionsHeader {
    background-color: #b5bad0;
    color:white;
    font-weight: 400;
    font-size: 25px;
    height:50px;
    padding: 15px;
}
.addButtonWrapper{
  margin-top:-5px;
}
.lptActionListItem{
    //background-image: url(../../assets/memphis-mini.png);
    
    color: #555;
    height: 60px;
    padding: 20px;
}
.lpt-login-wrapper {
  height: 100px;
}

.loginBtn{
  width:100%;
}
.login-group-element {
  margin-bottom: 5px;
}
.login {
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    padding: 30px 15px;
    background: #fff;
    width: 400px;
    
    .header {
      text-align: center;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
    }

    .error {
      background-color: red;
      padding: 10px;
      font-size: 12px;
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>
